(() => {
  // app/scripts/page-blog-cus.js
  var sectionId = document.querySelector(".section-blogs").dataset.sectionId;
  var limit = document.querySelector(".section-blogs").dataset.limit;
  handleClickTab();
  function handleClickTab() {
    const listTab = document.querySelectorAll(".content-header-tab__list-title .tab-title");
    listTab.length && listTab.forEach((tab) => tab.addEventListener("click", async (event) => {
      listTab.forEach((item) => item.classList.contains("active") ? item.classList.remove("active") : null);
      tab.classList.add("active");
      const dataUrl = event.target.dataset.url;
      const url = window.location.pathname + dataUrl;
      function callback(searchParams) {
        searchParams.set("section_id", sectionId);
      }
      const _url = url ? createUrlCustom(url, {}, callback) : null;
      const data = await fetchData(_url);
      const div = document.createElement("div");
      div.innerHTML = data;
      const body = div.querySelector(".content-body-wrapper");
      const showing = div.querySelector(".blogs-showing");
      updateBody(body);
      updateShowing(showing);
      handleClickBtnPagination();
    }));
  }
  function updateBody(element) {
    const body = document.querySelector(".content-body-wrapper");
    if (element) {
      body.parentNode.replaceChild(element, body);
    }
  }
  function updateShowing(element) {
    const showing = document.querySelector(".blogs-showing");
    if (element) {
      showing.parentNode.replaceChild(element, showing);
    }
  }
  function createUrlCustom(intURl = "", initParam = {}, callback) {
    const urlSearchParams = new URLSearchParams(initParam);
    if (callback && typeof callback === "function") {
      callback(urlSearchParams);
    }
    return intURl ? intURl + "?" + urlSearchParams.toString() : window.location.pathname + "?" + urlSearchParams.toString();
  }
  async function fetchData(url) {
    try {
      const response = await fetch(url);
      const data = await response.text();
      return data;
    } catch (error) {
      return error;
    }
  }
  function handleClickBtnPagination() {
    const paginationItems = document.querySelectorAll('ul.pagination li:not(:has(a[href="javascript:;"])):not(.ellipsis)');
    paginationItems.forEach((paginateLink) => {
      paginateLink.addEventListener("click", async (event) => {
        event.preventDefault();
        const href = paginateLink.querySelector("a").getAttribute("href");
        const url = href + `&section_id=${sectionId}`;
        const data = await fetchData(url);
        const div = document.createElement("div");
        div.innerHTML = data;
        const body = div.querySelector(".content-body-wrapper");
        updateBody(body);
        updateShowingPagination(url);
      });
    });
  }
  function updateShowingPagination(url) {
    const pageValue = getQueryStringValue(url, "page");
    const elmArticle = document.querySelectorAll(".card-article");
    const countFrom = (pageValue - 1) * limit + elmArticle.length;
    setShowing(countFrom);
    handleClickBtnPagination();
  }
  function setShowing(number, isFrom = true) {
    if (isFrom) {
      const showingFrom = document.querySelector(".jsUpdateShowingFrom");
      showingFrom.textContent = number;
    } else {
      const showingTo = document.querySelector(".jsUpdateShowingTo");
      showingTo.textContent = number;
    }
  }
  function getQueryStringValue(url, key) {
    const params = new URLSearchParams(url.split("?")[1]);
    return params.get(key);
  }
  handleClickBtnPagination();
})();
